import { render, staticRenderFns } from "./PbDashboardQueues.vue?vue&type=template&id=e911dd96&"
import script from "./PbDashboardQueues.js?vue&type=script&lang=js&"
export * from "./PbDashboardQueues.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports